import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const HTML_LANG = { en: 'en', gr: 'el' };

// Each domain owns its own file (src/locales/en/<domain>.json, src/locales/el/<domain>.json)
// so translation work on separate features never touches a shared file.
const mergeLocaleModules = (context) =>
  context.keys().reduce((acc, key) => Object.assign(acc, context(key)), {});

const enTranslation = mergeLocaleModules(require.context('./locales/en', false, /\.json$/));
const grTranslation = mergeLocaleModules(require.context('./locales/el', false, /\.json$/));

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      gr: { translation: grTranslation },
    },
    fallbackLng: 'gr', // Default language for first-time visitors
    detection: {
      // Only trust a language the user explicitly chose before; never infer
      // a default from the browser locale, so new visitors always see Greek.
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

const syncHtmlLang = (lng) => {
  document.documentElement.lang = HTML_LANG[lng] || 'el';
};
i18n.on('languageChanged', syncHtmlLang);
syncHtmlLang(i18n.language);

export default i18n;